import http from "../http-common";
import authHeader from './auth-header';

class CompanyDataService {

  getCompanies(){
    return http.get(`/root/companies`, {headers: authHeader()});
  }

  getCompany(companyID){
    return http.get(`/auth/companies/${companyID}`,{headers:authHeader()})
  }

  createCompany(name){
    return http.post(`/root/companies/create`,name,{headers: authHeader()});
  }

  editCompany(companyID,data){
    return http.post(`/super/${companyID}/edit`,data,{headers:authHeader()});
  }

  changeCompany(companyID,password){
    let data= {
      password: password
    }
    return http.post(`/auth/company/change/${companyID}`,data,{headers:authHeader()})
  }

  async getUsersOfSegment(segmentId) {
    return await http.get(`/super/segment/${segmentId}/users`,{headers: authHeader()})
  }

  getSegmentsOfCompany(companyId) {
    return http.get(`/leader/${companyId}/segments`,{headers:authHeader()})
  }

}

export default new CompanyDataService();